var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.01006C26.0424 7.68553 24.9821 8.20217 23.86 8.54006C23.2577 7.84757 22.4573 7.35675 21.567 7.13398C20.6767 6.91122 19.7395 6.96725 18.8821 7.29451C18.0247 7.62177 17.2884 8.20446 16.773 8.96377C16.2575 9.72309 15.9877 10.6224 16 11.5401V12.5401C14.2426 12.5856 12.5013 12.1959 10.931 11.4055C9.36074 10.6151 8.01032 9.44869 7 8.01006C7 8.01006 3 17.0101 12 21.0101C9.94053 22.408 7.48716 23.109 5 23.0101C14 28.0101 25 23.0101 25 11.5101C24.9991 11.2315 24.9723 10.9537 24.92 10.6801C25.9406 9.67355 26.6608 8.40277 27 7.01006Z",
    fill: "url(#paint0_linear_52_200)",
    stroke: "url(#paint1_linear_52_200)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_200",
    x1: 25.4286,
    y1: 8.63124,
    x2: 10.7275,
    y2: 26.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5390E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1357B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_200",
    x1: 25.4286,
    y1: 8.63124,
    x2: 10.7275,
    y2: 26.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5390E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1357B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.7415057087293ea9bebb33110a59e622.svg";
export { ForwardRef as ReactComponent };